/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceList
 */
export interface MaintenanceList {
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleStatus: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleManufacturer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleModel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleEngineType: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleManufactureYear: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehiclePurchaseDateOrContractTermStart: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleContractTermEnd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleContractDaysRemaining: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleInitialOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleCurrentOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleLastMaintenanceOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleLastMaintenanceDate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleNextMaintenanceHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleMaintenanceInterval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleMaintenanceNotificationAt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleMaintenanceLockdown: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleHoursUntilNextMaintenance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    vehicleTypeLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceList
     */
    departmentLabel: boolean;
}

/**
 * Check if a given object implements the MaintenanceList interface.
 */
export function instanceOfMaintenanceList(value: object): value is MaintenanceList {
    if (!('vehicleStatus' in value) || value['vehicleStatus'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('vehicleManufacturer' in value) || value['vehicleManufacturer'] === undefined) return false;
    if (!('vehicleModel' in value) || value['vehicleModel'] === undefined) return false;
    if (!('vehicleEngineType' in value) || value['vehicleEngineType'] === undefined) return false;
    if (!('vehicleManufactureYear' in value) || value['vehicleManufactureYear'] === undefined) return false;
    if (!('vehiclePurchaseDateOrContractTermStart' in value) || value['vehiclePurchaseDateOrContractTermStart'] === undefined) return false;
    if (!('vehicleContractTermEnd' in value) || value['vehicleContractTermEnd'] === undefined) return false;
    if (!('vehicleContractDaysRemaining' in value) || value['vehicleContractDaysRemaining'] === undefined) return false;
    if (!('vehicleInitialOperatingHours' in value) || value['vehicleInitialOperatingHours'] === undefined) return false;
    if (!('vehicleCurrentOperatingHours' in value) || value['vehicleCurrentOperatingHours'] === undefined) return false;
    if (!('vehicleLastMaintenanceOperatingHours' in value) || value['vehicleLastMaintenanceOperatingHours'] === undefined) return false;
    if (!('vehicleLastMaintenanceDate' in value) || value['vehicleLastMaintenanceDate'] === undefined) return false;
    if (!('vehicleNextMaintenanceHours' in value) || value['vehicleNextMaintenanceHours'] === undefined) return false;
    if (!('vehicleMaintenanceInterval' in value) || value['vehicleMaintenanceInterval'] === undefined) return false;
    if (!('vehicleMaintenanceNotificationAt' in value) || value['vehicleMaintenanceNotificationAt'] === undefined) return false;
    if (!('vehicleMaintenanceLockdown' in value) || value['vehicleMaintenanceLockdown'] === undefined) return false;
    if (!('vehicleHoursUntilNextMaintenance' in value) || value['vehicleHoursUntilNextMaintenance'] === undefined) return false;
    if (!('vehicleTypeLabel' in value) || value['vehicleTypeLabel'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    return true;
}

export function MaintenanceListFromJSON(json: any): MaintenanceList {
    return MaintenanceListFromJSONTyped(json, false);
}

export function MaintenanceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceList {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleStatus': json['vehicleStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'],
        'vehiclePurchaseDateOrContractTermStart': json['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': json['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': json['vehicleContractDaysRemaining'],
        'vehicleInitialOperatingHours': json['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': json['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': json['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': json['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': json['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': json['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': json['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': json['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': json['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'],
    };
}

export function MaintenanceListToJSON(json: any): MaintenanceList {
    return MaintenanceListToJSONTyped(json, false);
}

export function MaintenanceListToJSONTyped(value?: MaintenanceList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleStatus': value['vehicleStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehiclePurchaseDateOrContractTermStart': value['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': value['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': value['vehicleContractDaysRemaining'],
        'vehicleInitialOperatingHours': value['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': value['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': value['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': value['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': value['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': value['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': value['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': value['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': value['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
    };
}

